module.exports = {
  title: '平台奖励查看',
  route: {
    path: '/marketing-tools',
    children: {
      path: 'terrace-award-detail',
    },
  },
};
